(function () {
  var cfg = window.__pbBuyNow || {};
  var formSelector = cfg.formSelector;
  var checkoutUrl = cfg.checkoutUrl || '/checkout';
  var soldOutText = cfg.soldOutText || 'Sold out';
  var buyNowDefaultText = cfg.buyNowDefaultText || 'Buy now';
  var primaryActionsSelector = cfg.primaryActionsSelector || '[data-pb-primary-actions]';
  var buyNowBusy = false;

  if (!formSelector) return;

  function primaryActionsVisible(primaryActions) {
    if (!primaryActions) return false;
    var rect = primaryActions.getBoundingClientRect();
    var viewHeight = window.innerHeight || document.documentElement.clientHeight;
    return rect.top < viewHeight - 16 && rect.bottom > 16;
  }

  function nearPageBottom(sticky) {
    var footer = document.getElementById('t4s-footer');
    var stickyHeight = sticky && sticky.offsetHeight ? sticky.offsetHeight : 80;
    if (footer) {
      return footer.getBoundingClientRect().top < window.innerHeight - stickyHeight;
    }
    var scrollBottom = window.scrollY + window.innerHeight;
    var pageHeight = Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight
    );
    return scrollBottom >= pageHeight - 24;
  }

  function shouldSuppressSticky(sticky, primaryActions) {
    return primaryActionsVisible(primaryActions) || nearPageBottom(sticky);
  }

  function suppressStickyBar(sticky) {
    if (!sticky || !sticky.classList.contains('is--shown')) return;
    sticky.classList.remove('is--shown');
    document.documentElement.classList.remove('sticky-is--active');
  }

  function initStickyVisibility() {
    var primaryActions = document.querySelector(primaryActionsSelector);
    if (!primaryActions) return;

    function updateStickyVisibility(sticky) {
      if (shouldSuppressSticky(sticky, primaryActions)) {
        suppressStickyBar(sticky);
      }
    }

    function bindSticky(sticky) {
      if (!sticky || sticky.dataset.pbVisibilityBound === 'true') return;
      sticky.dataset.pbVisibilityBound = 'true';

      if (window.MutationObserver) {
        var classObserver = new MutationObserver(function () {
          if (sticky.classList.contains('is--shown')) {
            updateStickyVisibility(sticky);
          }
        });
        classObserver.observe(sticky, { attributes: true, attributeFilter: ['class'] });
      }

      var onScroll = function () {
        window.requestAnimationFrame(function () {
          updateStickyVisibility(sticky);
        });
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function () {
          updateStickyVisibility(sticky);
        }, { threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] });
        io.observe(primaryActions);
      }

      updateStickyVisibility(sticky);
    }

    function waitForSticky(attempts) {
      var sticky = document.querySelector('[data-sticky-addtocart]');
      if (sticky) {
        bindSticky(sticky);
        return;
      }
      if (attempts > 60) return;
      window.setTimeout(function () {
        waitForSticky(attempts + 1);
      }, 100);
    }

    waitForSticky(0);
  }

  function getProductForm() {
    return document.querySelector(formSelector);
  }

  function getVariantId() {
    var form = getProductForm();
    var input = form && form.querySelector('[name="id"]');
    if (input && input.value) return input.value;
    var btn = document.querySelector('[data-action-buy-now][data-variant-id]');
    return btn ? btn.getAttribute('data-variant-id') : null;
  }

  function getQuantity(triggerBtn) {
    var scope = triggerBtn.closest('.t4s-product-buy-box, [data-sticky-addtocart]');
    if (scope) {
      var scopedQty = scope.querySelector('[data-quantity-value]');
      if (scopedQty && scopedQty.value) return parseInt(scopedQty.value, 10) || 1;
    }
    var form = getProductForm();
    if (form) {
      var formQty = form.querySelector('[name="quantity"]');
      if (formQty && formQty.value) return parseInt(formQty.value, 10) || 1;
    }
    return 1;
  }

  function getLineItemProperties() {
    var form = getProductForm();
    var props = {};
    if (form) {
      var fd = new FormData(form);
      fd.forEach(function (value, key) {
        if (!value || key.indexOf('properties[') !== 0) return;
        var match = key.match(/^properties\[(.+)\]$/);
        if (match && match[1]) props[match[1]] = value;
      });
    }
    if (!props._design_id && cfg.designId) {
      props._design_id = String(cfg.designId);
    }
    if (!props._language && cfg.language) {
      props._language = String(cfg.language);
    }
    return props;
  }

  function setBuyNowLoading(btn, loading) {
    if (!btn) return;
    var spinner = btn.querySelector('.t4s-loading__spinner');
    var svg = btn.querySelector('.t4s-svg-spinner');
    if (loading) {
      btn.classList.add('is--loading');
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
      if (spinner) spinner.removeAttribute('hidden');
      if (svg) svg.removeAttribute('hidden');
    } else {
      btn.classList.remove('is--loading');
      btn.disabled = false;
      btn.removeAttribute('aria-disabled');
      if (spinner) spinner.setAttribute('hidden', '');
      if (svg) svg.setAttribute('hidden', '');
    }
  }

  function resetBuyNowUi() {
    buyNowBusy = false;
    document.querySelectorAll('[data-action-buy-now]').forEach(function (btn) {
      setBuyNowLoading(btn, false);
    });
    document.querySelectorAll('[data-action-atc].is--loading').forEach(function (btn) {
      btn.classList.remove('is--loading');
      var spinner = btn.querySelector('.t4s-loading__spinner');
      var svg = btn.querySelector('.t4s-svg-spinner');
      if (spinner) spinner.setAttribute('hidden', '');
      if (svg) svg.setAttribute('hidden', '');
    });
    mirrorAtcButtonState();
  }

  function mirrorAtcButtonState() {
    if (buyNowBusy) return;
    document.querySelectorAll('[data-action-buy-now]').forEach(function (buyBtn) {
      var scope = buyBtn.closest('.t4s-product-buy-box, [data-sticky-addtocart]');
      var atc = scope && scope.querySelector('[data-action-atc]');
      if (!atc) atc = document.querySelector('[data-action-atc]');
      if (!atc) return;
      var available = !atc.disabled && atc.getAttribute('aria-disabled') !== 'true';
      var variantId = atc.getAttribute('data-variant-id');
      var textEl = buyBtn.querySelector('.t4s-btn-buy-now_text');
      if (variantId) buyBtn.setAttribute('data-variant-id', variantId);
      if (available) {
        buyBtn.removeAttribute('disabled');
        buyBtn.removeAttribute('aria-disabled');
        if (textEl && textEl.textContent === soldOutText) textEl.textContent = buyNowDefaultText;
      } else {
        buyBtn.setAttribute('disabled', 'disabled');
        buyBtn.setAttribute('aria-disabled', 'true');
        if (textEl) textEl.textContent = soldOutText;
      }
    });
  }

  async function buyNow(triggerBtn) {
    if (buyNowBusy || !triggerBtn || triggerBtn.disabled || triggerBtn.getAttribute('aria-disabled') === 'true') return;

    var variantId = getVariantId();
    if (!variantId) return;

    buyNowBusy = true;
    setBuyNowLoading(triggerBtn, true);
    document.querySelectorAll('[data-action-buy-now]').forEach(function (btn) {
      if (btn !== triggerBtn) setBuyNowLoading(btn, true);
    });

    try {
      await fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
      });

      var properties = getLineItemProperties();
      var bundle = window.__pbBundleState;
      var payloadItems;

      if (bundle && bundle.items && bundle.items.length > 1) {
        var byId = {};
        var order = [];
        bundle.items.forEach(function (item, idx) {
          var id = String(item.id);
          if (!byId[id]) {
            byId[id] = { id: parseInt(item.id, 10), quantity: 0, isPrimary: false };
            order.push(id);
          }
          byId[id].quantity += 1;
          if (idx === 0) byId[id].isPrimary = true;
        });
        payloadItems = order.map(function (id) {
          var row = { id: byId[id].id, quantity: byId[id].quantity };
          if (byId[id].isPrimary && Object.keys(properties).length) row.properties = properties;
          return row;
        });
      } else {
        var item = {
          id: parseInt(variantId, 10),
          quantity: getQuantity(triggerBtn)
        };
        if (Object.keys(properties).length) item.properties = properties;
        payloadItems = [item];
      }

      var addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: payloadItems })
      });
      var addJson = await addRes.json().catch(function () { return {}; });
      if (!addRes.ok) {
        throw new Error(addJson.description || addJson.message || 'Could not add product to cart');
      }

      window.location.href = checkoutUrl;
    } catch (err) {
      buyNowBusy = false;
      document.querySelectorAll('[data-action-buy-now]').forEach(function (btn) {
        setBuyNowLoading(btn, false);
      });
      window.alert((err && err.message) ? err.message : 'Something went wrong. Please try again.');
    }
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-action-buy-now]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    buyNow(btn);
  }, true);

  var form = getProductForm();
  if (form) {
    var variantInput = form.querySelector('[name="id"]');
    if (variantInput) {
      variantInput.addEventListener('change', mirrorAtcButtonState);
    }
  }

  if (window.MutationObserver) {
    var observer = new MutationObserver(mirrorAtcButtonState);
    document.querySelectorAll('[data-action-atc]').forEach(function (btn) {
      observer.observe(btn, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'data-variant-id', 'class'] });
    });
  }

  initStickyVisibility();

  // Browser back from checkout restores bfcache with loading state still on
  window.addEventListener('pageshow', function () {
    resetBuyNowUi();
  });
  window.addEventListener('pagehide', function () {
    resetBuyNowUi();
  });
})();
